import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import categoryBanners from '../../misc/categoryLandingBanners';


export default class PageBanners extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { params, browser } = this.props;
    const categoryBannersCollection = categoryBanners;
    const imageMobileProportion = 1.0475;
    const imageTabletProportion = 0.41067961;
    const imageDesktopProportion = 0.30583333;
    let imageHeight = 0;

    let categoryName = '';
    let bannerCopy = '';
    let slug = '';

    if (params.rootSlug) {
      slug = params.rootSlug;

      // If there is a rootSlug this means we are on a child category
      // page so we don't want to show a banner.
      return <span />;
    } else {
      slug = params.slug;
    }

    if (categoryBannersCollection) {
      console.log('categoryBannersCollection')
      console.log(categoryBannersCollection)
      bannerCopy = categoryBannersCollection[slug].copy;
      categoryName = categoryBannersCollection[slug].category;
      if (browser.greaterThan.desktop) {
        //categoryName = categoryBannersCollection[slug].category;
      }
    }


    let bannerImageUrlDesktop = '/images/categories/lp_banners/desktop/' + slug + '.jpg';

    let bannerImageUrlTablet = '/images/categories/lp_banners/tablet/' + slug + '.jpg';

    let bannerImageUrlMobile = '/images/categories/lp_banners/mobile/' + slug + '.jpg';


    // Calculate image height so we can vertically align the banner copy
    // in the middle of the image



    if (browser.greaterThan.desktop) {
      imageHeight = 367;
    } else if (browser.greaterThan.phablet) {
      imageHeight = Math.round(browser.width * imageTabletProportion);
    } else {
      imageHeight = Math.round(browser.width * imageMobileProportion);
    }


    return <div className="categoryBanner-wrapper">
      <div className="categoryBanner-image">
        <img className="categoryBanner-desktop" src={`${bannerImageUrlDesktop}`} />

        <img className="categoryBanner-tablet" src={`${bannerImageUrlTablet}`} />

        <img className="categoryBanner-mobile" src={`${bannerImageUrlMobile}`} />
      </div>


      <div style={{height: imageHeight + 'px'}} className="categoryBanner-copy-outer">
        <div className="categoryBanner-copy-middle">
          <div className="categoryBanner-copy">
            <div className="categoryBanner-categoryTitle">{categoryName}</div>
            <div className="categoryBanner-categoryCopy">{bannerCopy}</div>
          </div>
        </div>
      </div>


    </div>;
  }
};



// WEBPACK FOOTER //
// ./src/components/categoryDetailLandingPage/PageBanners.jsx